<div style="padding: 10px; text-align: center; margin-top: 10%">
  <div>
    <fa-icon icon="user-lock" class="fa-2x" style="color: #1a1818"></fa-icon>
  </div>
  <div class="confirm_msg">Reset Password</div>
  <br />
  <div style="font-weight: 300">
    Please enter the email that you used to register {{ title() }}. <br />We
    will send you an email with a link to reset your password.
  </div>

  <div style="color: red; font-size: smaller; margin-top: 2em" *ngIf="error">
    {{ error }}
  </div>

  <div class="frame">
    <div>
      <mat-form-field>
        <input matInput [(ngModel)]="email" placeholder="Enter Your Email" />
      </mat-form-field>
    </div>

    <div>
      <button mat-flat-button (click)="proceed()">Reset Password</button>
    </div>
  </div>

  <div *ngIf="!mobile" style="margin-top: 2em">
    <a style="color: #1ca0da" [href]="link">Back to Login</a>
  </div>
</div>
